import manualFront from './manual/front.json';

export default {
  manual: {
    'identity-document-front': manualFront
  }
};
